import React from 'react';
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
} from '@mui/material';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';

interface Props {
  pageTitle: string;
  breadcrumbTitle: string;
  children?: React.ReactNode;
}

export const DashboardHeader: React.FC<Props> = ({
  pageTitle,
  breadcrumbTitle,
}) => {
  return (
    <Box
    >
      <Breadcrumbs
        separator={<ChevronRightRoundedIcon sx={{ fontSize: 15 }} />}
        aria-label="breadcrumb"
        sx={{
         
          '& .MuiBreadcrumbs-separator': {
            color: '#94A3B8',
          },
        }}
      >
        <Link
          underline="hover"
          href="/"
          color="inherit"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '0.82rem',
            fontWeight: 500,
            color: '#64748B',
            transition: 'all .2s',

            '&:hover': {
              color: 'var(--primaryColor, #116599)',
            },
          }}
        >
          <HomeRoundedIcon sx={{ fontSize: 16 }} />
          Accueil
        </Link>

        <Link
          underline="hover"
          href="#"
          color="inherit"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '0.82rem',
            fontWeight: 500,
            color: '#64748B',
            transition: 'all .2s',
            '&:hover': {
              color: 'var(--primaryColor, #116599)',
            },
          }}
        >
          <FolderRoundedIcon sx={{ fontSize: 16 }} />
          Gestion
        </Link>

        <Typography
          sx={{
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontSize: '0.82rem',
            fontWeight: 600,
            color: 'var(--primaryColor, #116599)',
          }}
        >
          {breadcrumbTitle}
        </Typography>
      </Breadcrumbs>
{/* 
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Plus Jakarta Sans","Inter","Segoe UI",sans-serif',
            fontWeight: 700,
            fontSize: '1.15rem',
            lineHeight: 1.25,
            letterSpacing: '-0.02em',
            color: '#1F2937',
          }}
        >
          {pageTitle}
        </Typography> */}

      {/* </Box> */}
    </Box>
  );
};